import * as React from 'react';

import { IState } from '../../../../../reducers';
import './SearchResult.css';

import { connect } from 'react-redux';

import { ISearchState } from '../../../../../app/Search/reducer';

import { fetchTopicDescription } from '../../../../../app/Search/actions';
import { ContentDialog } from '../../../../ContentDialog';
import { SearchResultAside } from './Aside';
import { SearchResultMain } from './Main';
import { Share } from './Share';

interface ISearchResultProps {
  searchResults: ISearchState;
  topic: {
    id: any;
    highlighted_texts: any;
    metadata: {
      title: string;
      identifier: string;
      description: string;
      topic_url: string;
      call_url: string;
      call_programme: string;
      call_identifier: string;
      call_title: string;
      call_status: string;
      topic_status: string;
      call_programme_description: string;
      publication_date: string;
      planned_opening_date: string;
      deadline1: string;
      tags: string[];
      keywords: string[];
      summary_terms: string[];
      budgets_from_call: any[];
      budget_groups: any[];
      trl_text: string;
    };
  };
  onDismiss: () => any;
  fetchTopicDescription: (v: any) => void;
  skipFetch?: boolean; // Add this prop to indicate the API was already called
}

class SearchResult extends React.Component<ISearchResultProps> {
  constructor(props: ISearchResultProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: ISearchResultProps) {
    // Always update if the topic changes
    if (this.props.topic?.id !== nextProps.topic?.id) {
      return true;
    }

    // Update if loading state changes
    if (this.props.searchResults.isDescriptionFetching !== nextProps.searchResults.isDescriptionFetching) {
      return true;
    }

    // Update if we get new description data
    const currentTopicId = this.props.topic?.id;
    if (currentTopicId) {
      const currentDescription = this.props.searchResults.topicDescription[currentTopicId];
      const nextDescription = nextProps.searchResults.topicDescription[currentTopicId];
      return currentDescription !== nextDescription;
    }

    return false;
  }

  componentDidMount() {
    // Always fetch fresh data when component mounts
    if (this.props.topic) {
      this.fetchDescription();
    }
  }

  componentDidUpdate(prevProps: ISearchResultProps) {
    // Always fetch fresh data when topic changes
    if (this.props.topic && (!prevProps.topic || prevProps.topic.id !== this.props.topic.id)) {
      this.fetchDescription();
    }
  }

  // Always fetch fresh data, don't check cache
  fetchDescription = () => {
    // Skip fetch if explicitly told to (when opened from SavedTopics)
    if (this.props.skipFetch) {
      return;
    }
    
    if (this.props.topic) {
      this.props.fetchTopicDescription({
        topicId: this.props.topic.id,
        query: this.props.searchResults.query,
      });
    }
  };

  render() {
    const { topic } = this.props;

    if (this.props.searchResults.topicDescription[topic.id] === undefined) {
      this.props.searchResults.topicDescription[topic.id] = "<b>For more details refer the Topic page..</b>"
    }

    const hideCurrentModal = () => {
      this.props.onDismiss();
      document.body.classList.remove('preventModalScrolling');
    };

    return (
      <ContentDialog
        loading={{
          title: !topic || !('metadata' in topic),
          content:
            !topic ||
            !('metadata' in topic) ||
            !(topic.id in this.props.searchResults.topicDescription) ||
            this.props.searchResults.isDescriptionFetching,
          aside: !topic || !('metadata' in topic),
        }}
        handleClose={hideCurrentModal}
        title={
          topic?.highlighted_texts && topic?.highlighted_texts?.title[0]
            ? topic?.highlighted_texts?.title[0].replace(/<(?:.|\n)*?>/gm, '')
            : topic?.metadata?.title.replace(/<(?:.|\n)*?>/gm, '')
        }
        content={<SearchResultMain searchResults={this.props.searchResults} topic={topic} />}
        aside={
          <SearchResultAside
            topic={topic}
            expectedContribution={this.props.searchResults.expectedContribution}
            indicativeNumberOfGrants={this.props.searchResults.indicativeNumberOfGrants}
          />
        }
        asideAfter={<Share topicMetadata={topic.metadata} />}
        aiSummary={this.props.searchResults.aiSummary}
      />
    );
  }
}
const mapStateToProps = ({ searchResults }: IState) => {
  return { searchResults };
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchTopicDescription: (data: any) => dispatch(fetchTopicDescription({ ...data })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult);
